import hashSum from 'hash-sum'

const AVATAR_COUNT = 16

const avatarPath = (avatarCount: number) => {
  return `/svg/avatars/avatar-${avatarCount}.svg`
}

// Return the path to the avatar image if it exists,
// Otherwise return the path to the character fallback image

export const getAvatarPath = (path: string | unknown, id: string | number) => {
  if (path && typeof path === 'string') {
    return path
  }

  const numericId = typeof id === 'string' ? parseInt(hashSum(id), 16) : id

  return avatarPath(Math.abs(numericId) % AVATAR_COUNT)
}

export const getRandomAvatarPath = () => {
  // random int between 0 and 15
  const randomInt = Math.floor(Math.pow(10, 14) * Math.random() * Math.random()) % (15 + 1)

  return `/svg/avatars/avatar-${randomInt}.svg`
}
